import React from 'react';
import PropTypes from 'prop-types';

export const TextFieldComponent = ({ label, multiline, rows, error, errorMessage, required, ...rest }) => (
  <label className="nmx-form__input">
    {label}{required && <span>&#42;</span>}
    {
      !multiline
        ? <input aria-required={required} {...rest} />
        : <textarea {...rest} rows={rows} />
    }
    {error && <small className='nmx-form__validation-error'>{errorMessage || 'Error'}</small>}
  </label>
);

TextFieldComponent.propTypes = {
  /** The label placed on the text field */
  label: PropTypes.string.isRequired,
  /** Placeholder text when no value is provided */
  placeholder: PropTypes.string,
  /** Name applied to input or textarea */
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'number']).isRequired,
  value: PropTypes.any.isRequired,
  /** Specify a max character length for the text field */
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  /** Should this be a textarea? */
  multiline: PropTypes.bool,
  /** Number of lines to show when multiline is true */
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  /** Is this input in an error state */
  error: PropTypes.bool,
  /** Message to display when error is true */
  errorMessage: PropTypes.string,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

TextFieldComponent.defaultProps = {
  type: 'text',
  value: '',
  onChange: () => {},
  multiline: false,
  rows: 5,
  disabled: false,
  error: false,
  errorMessage: 'Error',
  required: false,
};

export default TextFieldComponent;
